import React, { useRef, useState } from "react";
import arrow from "../../assets/img/hosting/Vector.svg";
const Accordion = ({ title, text ,extraIcon}) => {
  const [expand, setExpand] = useState(false);
  const ref = useRef(null)
  return (
    <div className={`Accordion ${expand ? "Accordion--active":"" }`} style={expand ? {
    maxHeight:`calc(${85 + ref.current.clientHeight}px)`
    }:{maxHeight:"85px"}}>
      <div className="d-flex-space Accordion-header" onClick={()=>setExpand(!expand)}>
        <h5>
          {title}
        </h5>
       <div className="flex gap-[12px] items-center">
         {extraIcon && extraIcon}
       <img className="Accordion-header--arrow" alt='arrow-down' src={arrow} />
       </div>
      </div>
      <div ref={ref} className="Accordion-body" >
        {text}
      </div>
    </div>
  );
};

export default Accordion;
